"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDynamicLinkedRecordArrayFilterField = exports.isDynamicLinkedRecordTextFilterField = exports.isDynamicLinkedRecordFilterField = void 0;
const isDynamicLinkedRecordFilterField = (filterField) => {
    return (!!filterField.is_dynamic_value &&
        (Array.isArray(filterField.value) || typeof filterField.value === "string"));
};
exports.isDynamicLinkedRecordFilterField = isDynamicLinkedRecordFilterField;
const isDynamicLinkedRecordTextFilterField = (filterField) => {
    return ((0, exports.isDynamicLinkedRecordFilterField)(filterField) &&
        typeof filterField.value === "string");
};
exports.isDynamicLinkedRecordTextFilterField = isDynamicLinkedRecordTextFilterField;
const isDynamicLinkedRecordArrayFilterField = (filterField) => {
    return ((0, exports.isDynamicLinkedRecordFilterField)(filterField) &&
        Array.isArray(filterField.value));
};
exports.isDynamicLinkedRecordArrayFilterField = isDynamicLinkedRecordArrayFilterField;
